// One row per object an Audiotool → Seedbed upload sends, as it goes — shared
// by the admin upload page and the web app's import page.

import { CheckCircle, Loader2 } from "lucide-react";
import { settled, type SampleRow } from "@web-shared/lib/audiotool-progress";

export function SampleList({ samples }: { samples: SampleRow[] }) {
  if (samples.length === 0) return null;
  return (
    <div className="max-h-48 divide-y divide-border overflow-y-auto rounded-lg border border-border bg-muted/30">
      {samples.map((s) => (
        <div key={s.id} className="flex items-center gap-2 px-3 py-1.5 text-xs">
          {settled(s.state) ? (
            <CheckCircle className="size-3.5 shrink-0 text-primary" />
          ) : (
            <Loader2 className="size-3.5 shrink-0 animate-spin text-muted-foreground" />
          )}
          <span className="min-w-0 flex-1 truncate text-muted-foreground">{s.displayName}</span>
          {s.bytes > 0 && <span className="shrink-0 text-muted-foreground">{Math.round(s.bytes / 1024)} KB</span>}
        </div>
      ))}
    </div>
  );
}
